import {
  Box,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BiTrash } from "react-icons/bi";
import styled from "styled-components";
import { useService } from "../view/Services/Provider";

const ShiftsWrap = styled.div`
  max-width: 93%;
  > div {
    display: grid;
    grid-template-columns: 450px 275px 40px;
    gap: 30px;
    position: relative;
    row-gap: 10;
  }
`;

const Wrapper = styled.div`
  display: flex;
  .trash {
    margin-top: 25px;
  }
  .addSite {
    display: block;
    justify-self: center;
    cursor: pointer;
    color: #95a4fc;
    text-decoration: underline;
  }
`;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddMoreRows = ({ props }) => {
  const theme = useTheme();
  const [selectedSite] = useState([]);
  const {
    state: { servicesBySite },
    fetchServiceNames,
  } = useService();

  const fetchServicesForSite = async (siteId) => {
    if (!siteId || servicesBySite[siteId]) return;

    try {
      await fetchServiceNames(siteId,true);
    } catch (error) {
      console.error(`Error fetching services for site ${siteId}:`, error);
    }
  };

  useEffect(() => {
    props.rows.forEach((row) => {
      if (row.siteId) {
        fetchServicesForSite(row.siteId);
      }
    });
  }, [props.rows]);

  const addSite = () => {
    props.setRows((rows) => {
      const newRows = [...rows, { siteId: "", serviceIds: [] }];
      return newRows;
    });
  };

  const removeSite = (index) => {
    const updatedRows = props.rows.filter((_, i) => i !== index);
    props.setRows(updatedRows);
    props.setValue(
      "siteIds",
      updatedRows.map((row) => row.siteId || row.id).filter((id) => id)
    );

    props.setValue(
      "serviceIds",
      updatedRows
        .filter((row) => row.serviceIds && row.serviceIds.length > 0)
        .flatMap((row) => row.serviceIds.map((service) => service.id))
        .filter((id) => id)
    );
  };

  const handleSiteChange = (index, siteId) => {
    selectedSite.push(siteId);
    props.setRows((rows) => {
      const updatedRows = rows.map((row, i) =>
        i === index ? { ...row, siteId, serviceIds: [] } : row
      );
      props.setValue(
        "siteIds",
        updatedRows.map((row) => row.siteId).filter((id) => id)
      );

      return updatedRows;
    });

    if (siteId) {
      fetchServicesForSite(siteId);
    }
  };

  const handleServicesChange = (index, selectedServiceIds) => {
    props.setRows((rows) => {
      const updatedRows = rows.map((row, i) =>
        i === index
          ? {
              ...row,
              serviceIds: selectedServiceIds.map((id) => ({ id })),
            }
          : row
      );

      props.setValue(
        "serviceIds",
        updatedRows
          .filter((row) => row.serviceIds && row.serviceIds.length > 0)
          .flatMap((row) => row.serviceIds.map((service) => service.id))
          .filter((id) => id)
      );

      return updatedRows;
    });
  };

  function displayShiftsFields() {
    return props.rows?.map((site, i) => {
      const currentSiteServices = servicesBySite[site.siteId] || [];

      return (
        <div key={i}>
          {props.role === "Site" ? (
            <Box>
              <span style={{ fontSize: "12px" }}>Site Name</span>
              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                {props?.adminOn?.siteName}
              </Box>
            </Box>
          ) : (
            <FormControl>
              <span style={{ fontSize: "12px" }}>{props.Labels[0]}</span>
              <TextField
                select
                size="small"
                value={site.siteId || ""}
                sx={{
                  width: theme.dimensions.width,
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                }}
                onChange={(e) => handleSiteChange(i, e.target.value)}
                required
              >
                {props.Lists[0] &&
                  props.Lists[0].map((c, index) => (
                    <MenuItem
                      disabled={selectedSite.includes(c.id) && true}
                      key={index}
                      value={c.id}
                    >
                      {c.name}
                    </MenuItem>
                  ))}
              </TextField>
            </FormControl>
          )}
          <div>
            <FormControl
              sx={{
                width: theme.dimensions.width,
              }}
              size="small"
            >
              <span style={{ fontSize: "12px" }}>Services</span>
              <Select
                labelId={`services-label-${i}`}
                id={`services-select-${i}`}
                multiple
                value={site.serviceIds?.map((s) => s?.id) || []}
                onChange={(e) => handleServicesChange(i, e.target.value)}
                input={<OutlinedInput label="Services" />}
                MenuProps={MenuProps}
                disabled={!site.siteId}
              >
                {currentSiteServices?.map((service) => (
                  <MenuItem key={service.id} value={Number(service.id)}>
                    {service.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {props.role !== "Site" && (
            <BiTrash onClick={() => removeSite(i)} className="trash" />
          )}
        </div>
      );
    });
  }

  return (
    <Wrapper>
      <ShiftsWrap>{displayShiftsFields()}</ShiftsWrap>
      {props.role !== "Site" && (
        <div>
          <p className="addSite" onClick={addSite}>
            {props.text}
          </p>
        </div>
      )}
    </Wrapper>
  );
};

export default React.memo(AddMoreRows);
